import { FieldValues } from "react-hook-form";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import useDateSubForm from "../hooks/useDateSubForm";

const DateSubForm = ({ formData, index, basekey }: { formData: FieldValues; index: number; basekey: string }) => {
  const { minDate, disabled } = useDateSubForm(formData, index);
  return (
    <>
      <CustomDateTimeInput source={`${basekey}.start_datetime`} label="Start" disabled={disabled} />
      <CustomDateTimeInput source={`${basekey}.end_datetime`} label="End" minDate={minDate} disabled={disabled} />
    </>
  );
};

export default DateSubForm;
